import { Component, Input, OnInit } from '@angular/core';

@Component({
	selector: 'app-icon-circle',
	templateUrl: './icon-circle.component.html',
	styleUrls: ['./icon-circle.component.scss']
})
export class IconCircleComponent implements OnInit {

	@Input()
	scale: string = "0.84"

	@Input()
	iconClass: string = ""

	@Input()
	big: boolean = false;

	@Input()
	stateColor: string | null = null

	iconBg!: string

	constructor() { }

	ngOnInit(): void {
		this.iconBg = this.iconClass + "-bg"
	}

	get currentIconClass(): string {
		if (this.iconClass == '') {
			return 'material-icons'
		}
		return 'material-icons ' + this.iconClass
	}

}
